module.exports = __webpack_public_path__ + "images/browser-logo-360-216f4f043046eb95d52ad8158de8c8c7.jpg";